import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobs } from '../behavior/jobs-sidecar'
import { assert } from '../lib/assert-sidecar'
import { scene } from '../main/scene-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { IMachine } from './machines'
import { common } from '../main/common-sidecar'

import { machines } from './machines-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'ice-melter')
}

const meltRate = 5

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  let jc = jobCreators.create(
    () => {
      if (obj.waterSupply > 0) {
        return false
      }
      if (!cargoes.existsOfType('ice')) {
        return false
      }
      return true
    },
    () => {
      let j = jobs.create('melt-ice')
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)
  let ds = common.getUpdateDeltaScaled()
  let ctx = scene.getContext()
  if (obj.waterSupply > 0) {
    obj.waterSupply -= meltRate * ds
    if (obj.waterSupply <= 0) {
      let cg = cargoes.create('water')
      cargoes.moveToTile(cg, ctx.mapShip, obj.i + 1, obj.j)
    }
  }
}
